import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';

function ErrorPage() {
    const navigate = useNavigate();
    const [errorData, setErrorData] = useState(null);

    useEffect(() => {
        // body 에 클래스를 추가하여 스타일 변경
        document.querySelector('#header').style.display = 'none';
        document.querySelector('#footer').style.display = 'none';

        const storedError = sessionStorage.getItem('errorData');
        if (storedError) {
            setErrorData(JSON.parse(storedError));
        }

        // 컴포넌트 언마운트 시 클래스 제거
        return () => {
            document.querySelector('#header').style.display = 'block';
            document.querySelector('#footer').style.display = 'block';
        };

    }, []);

    if (!errorData) {
        return (
            <div className="w_set">
                <div className="error-area">
                    <i className="error-500"></i>
                    <strong>죄송합니다.<br/>서비스 오류가 발생하였습니다.</strong>
                    <p>이용에 불편을 드려서 죄송합니다. 잠시 후에 다시 시도해주세요.</p>
                    <div className="btn-wrap">
                        <button type="button" className="btn color2" onClick={() => navigate(-1)}>이전페이지</button>
                        <button type="button" className="btn" onClick={() => navigate('/')}>메인으로</button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="w_set">
            <div className="error-area">
                <i className="error-500"></i>
                <strong>죄송합니다.<br/>서비스 오류가 발생하였습니다.</strong>
                <p>이용에 불편을 드려서 죄송합니다. 잠시 후에 다시 시도해주세요.</p>
                <div className="btn-wrap">
                    <button type="button" className="btn color2" onClick={() => navigate(-1)}>이전페이지</button>
                    <button type="button" className="btn" onClick={() => navigate('/')}>메인으로</button>
                </div>
            </div>
        </div>
    );
}

export default ErrorPage;
